import * as s from './Table.css'
import type { ScrollOverflowEdges } from './useScrollOverflowEdges'

function fadeClass(edge: boolean, edgeClass: string) {
  return [edgeClass, edge ? s.scrollFadeVisible : ''].filter(Boolean).join(' ')
}

export function ScrollOverflowFades({
  edges,
  insetLeftFadeAfterSelection = false,
  narrowSelectionColumn = false,
}: {
  edges: ScrollOverflowEdges
  /** When true, left fade starts at the right edge of the sticky checkbox column. */
  insetLeftFadeAfterSelection?: boolean
  /** Use the wider narrow-chrome checkbox column inset. */
  narrowSelectionColumn?: boolean
}) {
  const leftFadeClass = insetLeftFadeAfterSelection
    ? narrowSelectionColumn
      ? s.scrollFadeLeftAfterSelectionNarrow
      : s.scrollFadeLeftAfterSelection
    : s.scrollFadeLeft

  return (
    <>
      <div className={fadeClass(edges.top, s.scrollFadeTop)} aria-hidden />
      <div className={fadeClass(edges.bottom, s.scrollFadeBottom)} aria-hidden />
      <div className={fadeClass(edges.left, leftFadeClass)} aria-hidden />
      <div className={fadeClass(edges.right, s.scrollFadeRight)} aria-hidden />
    </>
  )
}
